export const FEATURE_FLAGS = {
  People: true,
  Schools: true,
  PersonalSchools: true,
  Events: false,
  Training: true,
  ReportsARBook: true,
  MobileApps: true,
  MobileAppUsers: true,
  LmsUsersList: true,
  Sites: true,
  Notifications: true,
  KnowledgeBase: true,
  Feedback: true,
  Giveaway: true,
  AskedQuestions: true,
  Settings: true,
  Onboarding: true,
  WhiteLabel: true,
  Books: true,
  BundlesStorage: true,
  ShareLinks: true,
  PromoCodes: true,
};
